/**
 *  Created by pw on 2022/11/4 4:51 PM.
 */
import { app } from '@ekuaibao/whispered';
export default function globleConfig(user) {
    if (user) {
        datafluxEventConfig(user);
        datafluxLogsConfig(user);
    }
}
export function datafluxEventConfig(user) {
    var _a, _b;
    var _c = app.require('@lib/logs'), isIncludesHost = _c.isIncludesHost, isTestHost = _c.isTestHost;
    var useDataflux = isIncludesHost() || isTestHost();
    var api = app;
    if (useDataflux && api.datafluxRum) {
        var _d = user.staff, _e = _d.id, id = _e === void 0 ? '' : _e, _f = _d.name, name = _f === void 0 ? '' : _f, _g = _d.corporation, corporation = _g === void 0 ? {} : _g, _h = _d.corporationId, corporationId = _h === void 0 ? {} : _h;
        api.datafluxRum.setUser({ id: id, name: name });
        api.datafluxRum.addRumGlobalContext('corpId', (corporationId === null || corporationId === void 0 ? void 0 : corporationId.id) || (corporation === null || corporation === void 0 ? void 0 : corporation.id));
        api.datafluxRum.addRumGlobalContext('corpName', (corporationId === null || corporationId === void 0 ? void 0 : corporationId.name) || (corporation === null || corporation === void 0 ? void 0 : corporation.name));
        api.datafluxRum.addRumGlobalContext('platform', window.__PLANTFORM__);
        api.datafluxRum.addRumGlobalContext('user-agent', window.navigator.userAgent);
        api.eventLog = function (name, object) {
            var _a;
            (_a = api.datafluxRum) === null || _a === void 0 ? void 0 : _a.addAction(name, object);
        };
        (_b = (_a = api.datafluxRum) === null || _a === void 0 ? void 0 : _a.addAction) === null || _b === void 0 ? void 0 : _b.call(_a, '用户登录系统', user.staff);
    }
}
export function datafluxLogsConfig(user) {
    var _a;
    var _b = (user === null || user === void 0 ? void 0 : user.staff) || {}, _c = _b.id, id = _c === void 0 ? '' : _c, _d = _b.name, name = _d === void 0 ? '' : _d, _e = _b.corporation, corporation = _e === void 0 ? {} : _e;
    var corpId = (corporation === null || corporation === void 0 ? void 0 : corporation.id) || '';
    var corpIdName = (corporation === null || corporation === void 0 ? void 0 : corporation.name) || '';
    var api = app;
    if (api === null || api === void 0 ? void 0 : api.logger) {
        (_a = api === null || api === void 0 ? void 0 : api.logger) === null || _a === void 0 ? void 0 : _a.setUserInfo({ id: id, name: name, corpId: corpId, corpIdName: corpIdName });
    }
}
